import { WebStorageService } from "ngx-webstorage-service";

export class SessionStorageUtility {
    public static  getSessionStorageData(sessionStorage:WebStorageService,key:any){
        return sessionStorage.get(key) ? JSON.parse(sessionStorage.get(key)) : null;
      }

    // Session stores dates as MM-dd-yyyy (the format the charts/API consumers need).
    // The uitk date picker requires ISO (yyyy-MM-dd) for prefill. These helpers convert
    // on read/write for picker screens. Both are idempotent so they tolerate either format.
    public static toIsoDate(value:any){
        if(value && /^\d{2}-\d{2}-\d{4}$/.test(value)){
            const [mm,dd,yyyy] = value.split('-');
            return `${yyyy}-${mm}-${dd}`;
        }
        return value;
    }

    public static toApiDate(value:any){
        if(value && /^\d{4}-\d{2}-\d{2}$/.test(value)){
            const [yyyy,mm,dd] = value.split('-');
            return `${mm}-${dd}-${yyyy}`;
        }
        return value;
    }

    public static getPickerDate(sessionStorage:WebStorageService,key:any){
        return SessionStorageUtility.toIsoDate(sessionStorage.get(key));
    }

    public static setPickerDate(sessionStorage:WebStorageService,key:any,value:any){
        sessionStorage.set(key, SessionStorageUtility.toApiDate(value));
    }
}